import { Component } from '@angular/core';

@Component({
    selector: 'mobilize-partners',
    imports: [
    ],
    templateUrl: './partners.component.html',
    styleUrl: './partners.component.scss'
})
export class PartnersComponent {
}
